/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ProductCharacteristicIdentification = {
    NotSpecified: 'NotSpecified',
    Tariff: 'Tariff',
    FuelQuantity: 'FuelQuantity',
    PowerActive: 'PowerActive',
    PowerReactive: 'PowerReactive',
    EnergyActive: 'EnergyActive',
    EnergyReactive: 'EnergyReactive',
} as const;
export type ProductCharacteristicIdentification = typeof ProductCharacteristicIdentification[keyof typeof ProductCharacteristicIdentification];

